import React, { Component } from 'react'
import { withTranslation } from 'react-i18next';
import styled from 'styled-components'
import GenericModal from '../../GenericModal'


const Content = styled.section`

  padding: 15px 20px 20px 20px;

  // Desktop version.
  @media (min-width: 768px) {
    height: 420px;
    overflow-y: auto;
  }  

  > p {
    font-family: Lato-Regular;
    font-size: 14px;
    color: #2B2B2B;
    line-height: 22px;
  }
`

export class ArticleDialog extends Component {

  createAccountHandler = (callback) => {
    this.props.onSelectedBroker()
  }

  render() {
    
    if (!this.props.visible) {
      return null
    }

    return (
      <GenericModal
        title={this.props.title}
        visible={true}
        onCloseDialog={this.props.onCloseDialog}
        width={800}
        className="article-dialog"
      >
        <Content>
          <p>{this.props.body}</p>
        </Content>
      </GenericModal>
    )
  }
}

export default withTranslation('translations')(ArticleDialog)

